module.exports = __webpack_public_path__ + "img/villa_dialog_icon08.e5439c36.png";